import { useState, useEffect } from 'react';
import ChatWindow from 'react-scale/components/pages/llm/chat-window';

export const RLHF = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setStep(3);
    }, 1000);
  }, []);

  useEffect(() => {
    if (step === 2) {
      setStep(3);
    }
  });

  return (
    <div className="bg-black relative w-full lg:flex lg:-translate-x-10 3xl:-translate-x-18 transition-transform duration-1000 ease-out rounded-lg shadow-xl xl:shadow-super overflow-hidden lg:mb-0 mb-9 lg:w-1/2 xl:w-[649px] xl:h-[402px] select-none aspect-[649/402] min-w-full lg:min-w-[50%] xl:min-w-[unset] max-w-max">
      <ChatWindow step={step} setStep={setStep} />
    </div>
  );
};
